import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";

const COLLAPSE_KEY = "sidebarCollapsed";

export function Layout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  // Sidebar mini a sole icone su desktop (2026-07-28, richiesta operatore):
  // sui dettagli/tabelle larghe i 240px della sidebar sono spazio sottratto al
  // contenuto. La preferenza e' per-postazione (localStorage), non per-utente:
  // dipende dallo schermo su cui si lavora, non da chi sei.
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem(COLLAPSE_KEY) === "1",
  );
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem(COLLAPSE_KEY, collapsed ? "1" : "0");
  }, [collapsed]);

  // Chiudi il drawer a ogni cambio route: da mobile, dopo aver scelto una voce
  // il menu si deve richiudere da solo lasciando spazio al contenuto.
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  // Blocca lo scroll del body mentre il drawer è aperto (solo mobile).
  useEffect(() => {
    if (!mobileOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [mobileOpen]);

  return (
    <div className={`app-shell${collapsed ? " sidebar-collapsed" : ""}`}>
      {/* Top bar mobile con hamburger — visibile solo sotto il breakpoint (CSS) */}
      <header className="mobile-topbar">
        <button
          type="button"
          className="mobile-topbar-toggle"
          aria-label="Apri menu di navigazione"
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen(true)}
        >
          <span className="material-symbols-outlined">menu</span>
        </button>
        <span className="mobile-topbar-title">Trusty Sieve</span>
      </header>

      {/* Backdrop: tap fuori dal drawer per chiudere */}
      {mobileOpen && (
        <div
          className="sidebar-backdrop"
          onClick={() => setMobileOpen(false)}
          aria-hidden="true"
        />
      )}

      <Sidebar
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed((v) => !v)}
      />
      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}
